import { FC } from "react"

import { ReactComponent as IconExport } from "@common_assets/svg/export.svg"
import { Box, Typography, styled } from "@mui/material"
import IconWrapper from "components/common/icon/iconWrapper"
import { PopRow } from "components/common/poprow"

import ExportRowChevron from "./ExportRowChevron"

const PopoverBox = styled(Box)(({ theme }) => ({
  display: "flex",
  columnGap: theme.spacing(1),
  alignItems: "center",
}))

interface IExportRowToggleProps {
  label: string
  isOpen: boolean
  onToggle: () => void
}

const ExportRowToggle: FC<IExportRowToggleProps> = ({
  label,
  isOpen,
  onToggle,
}) => (
  <li>
    <PopRow sx={{ width: "100%" }} onClick={onToggle} aria-expanded={isOpen}>
      <PopoverBox>
        <IconWrapper>
          <IconExport height="100%" width="100%" />
        </IconWrapper>
        <Typography component="span" variant="body2" fontWeight="500">
          {label}
        </Typography>
        <ExportRowChevron isOpen={isOpen} />
      </PopoverBox>
    </PopRow>
  </li>
)

export default ExportRowToggle
